import { ProductType } from '@flipster/apis/v1/history/types';

import { HistoryTabGroup } from '../constants';

export const getProductType = (historyGroup: HistoryTabGroup) => {
  switch (historyGroup) {
    case 'Perpetual':
      return ProductType.Perpetual;
    case 'Spot':
      return ProductType.Spot;
    default:
      return undefined;
  }
};
